module.exports = __webpack_public_path__ + "static/media/23.dc2c9b27.jpg";